import React from 'react';
import { Stack, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

type CandidateProfileConversationHeaderProps = {
  onClose?: () => void;
};

export const CandidateProfileConversationHeader: React.FC<
  CandidateProfileConversationHeaderProps
> = ({ onClose }) => {
  return (
    <Stack direction="row" alignItems="flex-start" justifyContent="flex-end">
      {onClose && (
        <IconButton onClick={onClose} size="small" color="primary">
          <Close />
        </IconButton>
      )}
    </Stack>
  );
};
